interface ChipProps {
  label: string;
  selected: boolean;
  onToggle: () => void;
  disabled?: boolean;
}

/**
 * Multi-select filter chip. Any number can be active at once, and toggling one
 * resets catalogue pagination to offset 0 — that reset is the caller's job, not
 * the server's.
 */
export function Chip({ label, selected, onToggle, disabled = false }: ChipProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={selected}
      disabled={disabled}
      onClick={onToggle}
      className={[
        'shrink-0 rounded-full px-4 font-medium transition-colors select-none',
        // Full touch height even though the chip looks small — a 32px chip is a
        // miss-tap on a handheld device.
        'min-h-(--size-touch-min) text-sm',
        selected
          ? 'bg-accent text-on-accent'
          : 'bg-surface text-secondary border border-(--color-border-default)',
        disabled ? 'opacity-50' : '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {label}
    </button>
  );
}
